import Stripe from "stripe";
const stripe = new Stripe(process.env.STRIPE_SECRET_KEY as string, {
  apiVersion: "2020-08-27",
});
import { sort } from "fast-sort";
import RegistartionForm from "../components/registration-form";
import Navbar from "../components/navbar";
import { NextSeo } from "next-seo";
import Footer from "../components/footer";
import dayjs from "dayjs";
import { NextApiRequest, NextApiResponse } from "next";

interface FarawayFairwaysProps {
  prices: any[];
}

const year = dayjs().year();

export default function Registartion({ prices }: FarawayFairwaysProps) {
  return (
    <div className="w-full block mx-auto">
      <NextSeo title={`What's new in Breast Cancer ${year}`} />
      <Navbar />
      <div className="pt-16">
        <RegistartionForm
          prices={prices}
          title={`What's new in Breast Cancer ${year}`}
          logoUrl="affiliations/AHN_CMYK.jpg"
          registrationType="symposium"
        />
      </div>
      <Footer />
    </div>
  );
}

export async function getServerSideProps() {
  const isPreview = process.env.VERCEL_ENV === "preview";

  const prices = await stripe.prices.list({
    product:
      process.env.NODE_ENV === "production" && !isPreview
        ? "prod_PXPRPmiG8KjETv"
        : "prod_PXPTzsvikelfNz",
    active: true,
  });

  return {
    props: {
      prices: sort(prices.data).by([
        { desc: (p) => p.unit_amount },
        { desc: (p) => p.nickname },
      ]),
    },
  };
}
